import React from 'react';
import { LearnAndEarn } from '../components/LearnEarn/LearnEarn';
import useSEO from '../utils/useSEO';

const LearnEarnPage = () => {
  useSEO({
    title: 'Learn & Earn | Student Services — Assignment Writing, Workshop & More | AGO Innovations',
    description:
      'AGO Innovations Learn & Earn platform — assignment writing service, journal writing, workshops, curriculum activities, and student earning programs. Join and earn while you learn.',
    keywords:
      'learn and earn, assignment writing, journal writing service, workshop for students, curriculum activities, student earning India, earn money as student',
    canonical: 'https://agoinnovations.in/learn',
  });

  return <LearnAndEarn />;
};

export default LearnEarnPage;